var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrapp_loader"}},[(_vm.goLoader)?_c('div',{style:({backgroundColor:("" + (this.$store.state.color))}),attrs:{"id":"loader"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }